import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { UserDetailApiResponse, UserDetailData } from "./UserDetailType";
import "../../css/UserDetail.css";
import { axiosSettings } from "../../axios/axios";
import { useHistory } from "react-router-dom";
import { DateConverter } from "../../utils/DateConverter";

const UserDetail: React.FC = () => {
  type Item = {
    user_id: string;
  };
  const location = useLocation();
  const item = location.state as Item;

  const [userDetail, setUserDetail] = useState<UserDetailData[] | null>(null);
  const [rentLog, setRentLog] = useState([]);
  const [custCode, setCustCode] = useState<string | null>(null);

  const history = useHistory();

  const handleDoubleClick = (rentId: string) => {
    history.push("/Ride_adjustment", { rent_id: rentId });
  };

  // idで詳細情報を検索
  // 非同期処理
  useEffect(() => {
    axiosSettings
      .get(`api-admin/user/${item.user_id}`)
      .then(function (res) {
        if (res.data.status === "Success") {
          setUserDetail(res.data.data.result.user_detail);
          setRentLog(res.data.data.result.rent_log);
        }
      })
      // エラー吐いたら
      .catch(function (error) {
        alert(error);
      });

    // レンタルログを取得
    axiosSettings
      .get(`api-admin/afterrental/rent-log`)
      .then(function (res) {
        if (res.data.status === "Success") {
          const logs = res.data.data.result;
          const userLog = logs.find((log: any) => log.user_id === item.user_id);
          if (userLog) {
            setCustCode(userLog.cust_code);
          }
        }
      })
      .catch(function (error) {
        alert(error);
      });
  }, [item.user_id]);

  return (
    <div className="position_row">
      <div className="user_detail_container">
        {userDetail !== null && (
          <div className="user_detail_title">
            {userDetail[0].email}/ {userDetail[0].family_name}{" "}
            {userDetail[0].first_name} 様
          </div>
        )}
        <table className="item_container">
          <thead>
            <tr className="user_detail_item_container">
              <td className="item">電話番号</td>
              <td className="item">認証</td>
              <td className="item">生年月日</td>
              <td className="item">年齢</td>
              <td className="item">性別</td>
              <td className="item">住所</td>
              <td className="item">登録日</td>
              <td className="item">クーポン</td>
              <td className="item">顧客コード</td>
            </tr>
          </thead>
          <tbody>
            {userDetail !== null &&
              userDetail.map((item: any) => (
                <tr key={item.user_id} className="user_detail_item_container">
                  <td className="item">{item.phone_number}</td>
                  <td className="item">{item.status}</td>
                  <td className="item">{item.date_of_birth}</td>
                  <td className="item">{item.age}</td>
                  <td className="item">{item.gender}</td>
                  <td className="item">{item.address}</td>
                  <td className="item">{DateConverter(item.account_creation_date)}</td>
                  <td className="item">
                    {console.log(item.coupon_id_list)}
                    {
                      (item.coupon_id_list 
                        ? item.coupon_id_list.toString().split(", ") 
                        : [])
                    }
                  </td>
                  <td className="item">{custCode}</td>
                </tr>
              ))}
          </tbody>
        </table>
        <h1 className="user_log_title">レンタル履歴</h1>
        <table className="item_container">
          <thead>
            <tr className="user_log_item_container">
              <td className="box">レンタルID</td>
              <td className="item">開始ポート</td>
              <td className="item">終了ポート</td>
              <td className="item">開始時間</td>
              <td className="item">終了時間</td>
              <td className="item">発生料金</td>
              <td className="item">クーポン</td>
              <td className="item">料金</td>
              <td className="item">支払い</td>
            </tr>
          </thead>
          <tbody>
            {rentLog !== null &&
              rentLog.map((item: any) => (
                <tr
                  key={item.rent_id}
                  className="user_log_item_container"
                  onDoubleClick={() => handleDoubleClick(item.rent_id)}
                >
                  <td className="box">{item.rent_id}</td>
                  <td className="item">{item.start_port_name}</td>
                  <td className="item">{item.end_port_name}</td>
                  <td className="item">{DateConverter(item.start_date)}</td>
                  <td className="item">{DateConverter(item.end_date)}</td>
                  <td className="item">{item.fee}</td>
                  <td className="item">{item.coupon_name}</td>
                  <td className="item">{item.remaining_fee}</td>
                  <td className="box">{item.success}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserDetail;